// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3pNvP","title":"InfoRow_title__32nAg"};